import { Component, EventEmitter, Input, Output, ChangeDetectorRef } from '@angular/core';
import { CommonModule, DatePipe, CurrencyPipe } from '@angular/common';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzAlertModule } from 'ng-zorro-antd/alert';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { PagoSolicitudReembolso } from '../../models';
import { ReportesService } from '../../services/reportes.service';
import { finalize } from 'rxjs';
import { ImportsModule } from "../../imports.module";
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzDrawerRef } from 'ng-zorro-antd/drawer';


@Component({
  selector: 'app-actualizar-reportes',
  standalone: true,
  imports: [
    CommonModule,
    DatePipe,
    CurrencyPipe,
    NzButtonModule,
    NzTableModule,
    NzAlertModule,
    NzIconModule,
    ImportsModule,
    NzIconModule,
    NzSpinModule
],
  templateUrl: './actualizar-reportes.component.html',
  styleUrl: './actualizar-reportes.component.scss'
})
export class ActualizarReportesComponent {
  @Input() reportes ?: PagoSolicitudReembolso[];
  @Output() cerrar: EventEmitter<void> = new EventEmitter<void>();
  actualizando: boolean = false;

  constructor(private reportesService: ReportesService, private cdr: ChangeDetectorRef, private messageService: NzMessageService, private drawerRef: NzDrawerRef) { }

  ngOnInit(): void {
  }

  actualizar(): void {
    this.actualizando = true;
    this.reportesService.actualizarReportes(this.reportes || [])
    .pipe(
      finalize(() => {
        this.actualizando = false;
        this.cdr.detectChanges()
      })
    )
    .subscribe({
      next: (response) => {
        this.messageService.success('Reportes actualizados correctamente');
        this.drawerRef.close();
      },
      error: (error) => {
        console.error('Error al actualizar reportes:', error);
        this.messageService.error('Error al actualizar reportes');
      }
    });
  }

  getEstatusColor(estatus: string | null | undefined): string {
    switch(estatus?.toLowerCase()) {
      case 'autorizado':
      case 'aprobado':
        return '#00A226';
      case 'rechazado':
        return '#E31F42';
      case 'en revisión':
      case 'en revision':
      case 'pendiente':
      case 'proceso':
        return '#0234D7';
      case 'pagado':
        return '#00A226';
      default:
        return '#0234D7';
    }
  }

  getEstatusIcon(estatus: string | null | undefined): string {
    switch(estatus?.toLowerCase()) {
      case 'autorizado':
      case 'aprobado':
      case 'pagado':
        return 'assets/icon/success.svg';
      case 'rechazado':
        return 'assets/icon/refuse.svg';
      case 'en revisión':
      case 'en revision':
      case 'pendiente':
      case 'proceso':
      default:
        return 'assets/icon/process.svg';
    }
  }
}
